module.exports = __webpack_public_path__ + "img/ring_y_s_0_null.f7e69325.png";